export default {"src":"/sg/_next/static/media/Payment.c932638e.svg","height":84,"width":84,"blurWidth":0,"blurHeight":0};